import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { TabNav, TabsNav } from '@fly/core';
import { routes } from '@fly/shared';

export function RegistryLayout() {
  const { t } = useTranslation();
  const tabs = useMemo(
    () =>
      [
        {
          to: routes.DASHBOARD.REGISTRY.GIT_REPOSITORIES,
          label: t('app.dashboard.registry.tabs.git_repositories', {
            defaultValue: 'Git Repos',
          }),
          iconStart: 'git',
        },
        {
          to: routes.DASHBOARD.REGISTRY.ARTIFACTS,
          label: t('app.dashboard.registry.tabs.all_artifacts', {
            defaultValue: 'All Artifacts',
          }),
          iconStart: 'artifact',
        },
      ] satisfies TabNav[],
    [t]
  );

  return (
    <>
      <TabsNav
        size='2'
        tabs={tabs}
        className='relative -left-fly-7 w-[calc(100%+56px)] overflow-visible pl-fly-5'
      />
      <Outlet />
    </>
  );
}
